import * as React from 'react'
import dataStore from '../../store/dataStore.ts'
import historyStore from '../../store/historyStore.ts'
import { IDevice } from '../../interfaces/types.ts'
import { HistoryEngine } from './HistoryEngine.tsx'
import { HistoryButtons } from './HistoryButtons.tsx'
import controlStore from '../../store/controlStore.ts'
import { petFromDevice } from '../../helpers/dataHelpers.ts'

export enum PlaybackMode {
    MOVIE,
    PAGE,
}

interface Props {
    controlRef?: any
    noPets?: boolean
    showLabel?: boolean
}

export const HistoryControl: React.FC<Props> = (props) => {
    const devices: IDevice[] = dataStore(s => s.devices)
    const isMobile = controlStore(s => s.isOnMobileDevice)
    // const petId = historyStore(s => s.selectedPetId)
    // const pets = dataStore(s => s.pets)
    // const pet = pets.find(p => p._id === petId)
    // const navigate = useNavigate()

    React.useEffect(() => {
        if (devices) {
            // const all = devices.map(d => d.petId).filter(n => n)
            const all = devices.map(d => petFromDevice(d)).filter(n => n).map(p => p?._id).filter(n => n)
            // console.log('historyPets', all)
            historyStore.getState().setHistoryPets(all as string[])
            if (!historyStore.getState().selectedPetId) {
                historyStore.getState().setSelectedPetId((all as string[])[0])
            }
        }
    }, [devices])
    //
    // const desktop = (
    //     <div id={'desktop-control'} className={' p-2'}>
    //         <div className={'flex flex-col gap-1 justify-center items-center'}>
    //             {/*<SwitchPet showName/>*/}
    //             {/*<InvalidToggle/>*/}
    //             <div className={'flex flex-row gap-12 justify-center items-center'}>
    //                 <div className={'text-xl text-primary-content font-bold'}>
    //                     {pet?.petName}
    //                 </div>
    //                 <div
    //                     className={''} onClick={() => navigate('/map')}>
    //                     <FontAwesomeIcon icon={faClose} fontSize={'medium'} size={'lg'} color={'white'}/>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // )

    return (
        <div className={`relative flex flex-col w-ful h-full justify-start items-center pb-1 py-2`}
             ref={props.controlRef}>
            {isMobile ? <HistoryButtons/> : null}
            <HistoryEngine/>
        </div>
    )
}
